import { RouteName } from "app/routes";
import { State } from "store/metaFlightDetails/state";
import { LANDING_OFFER_FROM_META_KEY } from "../constants";
import { isOfMetaOrigin } from "./marketing-url-params";
import { flightsSessionStore } from "@flights/web-api-utils-universal";

const isMetaOrigin = isOfMetaOrigin();
// In meta flow we wait for offer key to highlight from FORAP api call response
/**
 * useClientFetch hook has a parameter throught which we can decide whether to call the endpoint or not. The only trigger which will recall the endpoint in the hook is any change in the api url. We use the condition parameter of useClientFetch hook to synthetically delay the call by holding it off and when the desired criteria is met, update a param on the url through which hook will render again
 *
 * Hence, the idea here is to first short circuit the holding of API call until the valid condition is met.
 * Valid condition on when to hold off this particular call:
 *  1. Is a meta landing. we identify this with if the offer token in the url is same as the landing offer token
 *  2. also if the meta offer(forap) has returned with a response or not
 * PS: this logic is to only hold off the SR call and not check which offerKey is being passed down. That logic resides in useFlightDetailsFromSearchResults.ts
 *
 * @returns status if waiting for offer key to highlight on meta
 */
export const isWaitingForOfferKeyToHighlight = (routeName: RouteName, metaFlightDetails: State) => {
  const isLandingMetaOffer = location.pathname.indexOf(flightsSessionStore.get(LANDING_OFFER_FROM_META_KEY)) > -1;
  if (isMetaOrigin && routeName.includes("flightdetails") && isLandingMetaOffer) {
    return ["initial", "loading"].includes(metaFlightDetails.fetchStatus);
  }
  return false;
};
